import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import SaveButton from '@ui-elements/SaveButton';
import BasicModal from '@ui-parts/BasicModal';
import RadioGroup from '@ui-parts/RadioGroup';

import { QUALIFICATION_GENDER_TYPE } from '~/constants';
import { PALETTE } from '~/assets/styles/base';

const BodyWrapper = styled.div`
  padding: 0 15px;
`;

function GenderModal({ open, handleClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const gender = useSelector((state) => state.qualifications.current.gender);
  const [selectedGender, setSelectedGender] = useState(gender);

  useEffect(() => {
    setSelectedGender(gender);
  }, [gender]);

  return (
    <BasicModal
      open={open}
      titleProps={{
        titleLabel: t('quotas.deliveryTarget'),
        title: t('quotas.conditions.titles.gender'),
        desc: t('quotas.modals.gender.desc'),
      }}
      handleClose={() => {
        handleClose();
        // 選択状態を元に戻してあげる
        setSelectedGender(gender);
      }}
      buttons={[
        <SaveButton
          key="button1"
          sx={{ width: 148 }}
          handleClick={() => {
            dispatch({
              type: 'qualifications/changed',
              payload: {
                key: 'gender',
                value: selectedGender,
              },
            });
            handleClose();
          }}
          label={t('appCommon.setting')}
        />,
      ]}
      dataTestId="GenderModal"
      width="33%"
    >
      <BodyWrapper>
        <RadioGroup
          defaultValue={gender}
          radios={[
            {
              value: QUALIFICATION_GENDER_TYPE.EACH,
              label: t('quotas.conditions.gender.each'),
            },
            {
              value: QUALIFICATION_GENDER_TYPE.MALE,
              label: t('quotas.conditions.gender.male'),
            },
            {
              value: QUALIFICATION_GENDER_TYPE.FEMALE,
              label: t('quotas.conditions.gender.female'),
            },
            {
              value: QUALIFICATION_GENDER_TYPE.BOTH,
              label: t('quotas.conditions.gender.both'),
            },
          ]}
          handleChange={(e) => {
            setSelectedGender(Number(e.target.value));
          }}
          styles={css`
            & .MuiFormControlLabel-root {
              padding: 15px 15px 10px;
              border-bottom: 1px solid ${PALETTE.border.modalItemBottom};
            }
            & .MuiFormControlLabel-root:nth-of-type(1) {
              padding-top: 0;
            }
          `}
          isVertical
        />
      </BodyWrapper>
    </BasicModal>
  );
}

GenderModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default GenderModal;
